import type { FC } from 'react';
import { useState } from 'react';
import { delikateskaAvatar } from '@images';
import { Picture, IconText } from '@ui';
import dayjs from 'dayjs';
import RateAnswerModal from '@components/Modals/RateAnswerModal';
import icons from '@icons';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { useStores } from '@root/src/stores';
import './index.scss';

const {
  star: { yellow: starYellowFilled }
} = icons.Fill;
const {
  thumbsUp: { darkGrey: thumbsUpOutlinedDarkGrey, red: thumbsUpOutlinedRed }
} = icons.Outline;

const getDate = (date: string): string => dayjs(date).format('DD MMMM YYYY');

interface ReviewReplyProps {
  reviewType;
  reviewId;
  onSuccessfulRateAnswer?: () => void;
  answer;
  messageUserId?: number | null | undefined;
  answerUserAvatar;
  answerUserFio;
  answerDate;
  isCanRateAnswer;
  answerRating;
  isBarMenu?: boolean;
}

const ReviewReply: FC<ReviewReplyProps> = observer(
  ({
    reviewType,
    reviewId,
    onSuccessfulRateAnswer,
    answer,
    answerUserAvatar,
    answerUserFio,
    messageUserId,
    answerDate,
    isCanRateAnswer,
    answerRating,
    isBarMenu
  }) => {
    const { userStore } = useStores();
    const userId = userStore?.user?.id;
    const [isRateAnswerPopupOpened, setIsRateAnswerPopupOpened] =
      useState(false);
    const onModalClose = (): void => {
      setIsRateAnswerPopupOpened(false);
    };
    const openModal = (): void => {
      setIsRateAnswerPopupOpened(true);
    };
    const date = getDate(answerDate);
    return (
      <div className='ReviewReply'>
        <div className='ReviewReply__avatar-wrapper'>
          <Picture
            pictureClassName='ReviewReply__avatar'
            width={44}
            height={44}
            icon={answerUserAvatar || delikateskaAvatar}
            alt={answerUserFio || 'Деликатеска'}
          />
        </div>
        <div className='ReviewReply__info-wrapper'>
          <div className='ReviewReply__name'>
            {answerUserFio || 'Деликатеска'}
          </div>
          <div className='ReviewReply__date'>{date}</div>
          {answer && (
            <div
              className={clsx(
                'ReviewReply__text',
                isBarMenu && 'ReviewReply__text--disabled-links'
              )}
              dangerouslySetInnerHTML={{
                __html: answer.replace(/(?:\r\n|\r|\n)/g, '<br />')
              }}
            />
          )}
          {answerRating ? (
            messageUserId === userId ? (
              <div className='ReviewReply__star-wrapper'>
                <div className='ReviewReply__star'>
                  <Picture icon={starYellowFilled} width='20' height='20' />{' '}
                  {answerRating}
                </div>
                Ваша оценка
              </div>
            ) : null
          ) : isCanRateAnswer ? (
            <>
              <IconText
                onClick={openModal}
                className='ReviewReply__rate-answer'
                height='20'
                icon={thumbsUpOutlinedDarkGrey}
                iconHover={thumbsUpOutlinedRed}
                marginRight='8'
                text='Оценить ответ'
                fontSize='14'
                withCursor
                hoverColor='red'
                color='grey'
              />
              {isRateAnswerPopupOpened && (
                <RateAnswerModal
                  onModalClose={onModalClose}
                  reviewId={reviewId}
                  reviewType={reviewType}
                  onSuccessfulRateAnswer={onSuccessfulRateAnswer}
                />
              )}
            </>
          ) : null}
        </div>
      </div>
    );
  }
);

export default ReviewReply;
